import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

class DateSelector extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { className, style, dates, selectedDate, onChange, labelPrevious, labelNext, t } = this.props;

		const sortedDates = dates.sort((a, b) => moment(a) - moment(b));
		const previousDate = sortedDates.findLast(x => moment(x) < moment(selectedDate));
		const nextDate = sortedDates.find(x => moment(x) > moment(selectedDate));

		return <ButtonGroup className={className} style={style}>
			<Button disabled={!previousDate} onClick={() => onChange(previousDate)}><span><FontAwesomeIcon icon={faAngleDoubleLeft} /> <span className='hidden-xxs'>{labelPrevious || t('WorkshopAttendance_PrevDay')}</span></span></Button>
			<DropdownButton id='weekDateSelect' title={moment(selectedDate).format('LL')}>{sortedDates.map(x => <MenuItem key={x} eventKey={x} onSelect={value => onChange(value)}>{moment(x).format('LL')}</MenuItem>)}</DropdownButton>
			<Button disabled={!nextDate} onClick={() => onChange(nextDate)}><span><span className='hidden-xxs'>{labelNext || t('WorkshopAttendance_NextDay')}</span> <FontAwesomeIcon icon={faAngleDoubleRight} /></span></Button>
		</ButtonGroup>;
	}
}

DateSelector.propTypes = {
	dates: PropTypes.arrayOf(PropTypes.string),
	selectedDate: PropTypes.string,
	onChange: PropTypes.func
};

export default withTranslation()(DateSelector);